export default __webpack_public_path__ + "static/media/help-icon.244a194c.svg";